import { Reveal } from "@/components/site/Reveal";
import { useContent } from "@/context/ContentContext";

const chapters = [
  { n: "01", title: "Professional Introduction", key: "intro" },
  { n: "02", title: "Approach to Patient Care", key: "approach" },
];

export function About() {
  const { content } = useContent();
  const f = content.about.fields;
  const editable = [
    ["Medical Qualification", f.qualification],
    ["Years of Experience", f.experience],
    ["Professional Memberships", f.memberships],
    ["Areas of Clinical Expertise", f.expertise],
    ["Languages Spoken", f.languages],
  ];

  return (
    <section id="about" className="py-24 md:py-32 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="label">About</span>
              <h2 className="font-display text-4xl sm:text-5xl tracking-tight leading-tight mt-4 text-[#0A192F]">
                About Dr. Sangeeta Roy
              </h2>
            </Reveal>
            <Reveal delay={0.15} className="mt-8 relative rounded-[1.5rem] overflow-hidden aspect-[4/5] max-w-sm bg-[#F4F7FA]">
              <div className="absolute -bottom-4 -right-4 w-20 h-20 rounded-2xl bg-[#0D9488] -z-10 hidden sm:block" />
              <img
                src="https://images.unsplash.com/photo-1602052577122-f73b9710adba?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Pharmacology research and laboratory environment"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pt-16">
            {chapters.map((c, i) => (
              <Reveal key={c.n} delay={0.1 * i} className="mb-12 border-t border-[#E2E8F0] pt-6">
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-sm text-[#64748B]">{c.n}</span>
                  <div>
                    <h3 className="font-display text-2xl text-[#0A192F] mb-3">{c.title}</h3>
                    <p className="text-[#475569] leading-relaxed text-lg max-w-2xl">{content.about[c.key]}</p>
                  </div>
                </div>
              </Reveal>
            ))}

            <Reveal delay={0.1} className="mt-4">
              <h3 className="font-display text-2xl text-[#0B1B2B] mb-6">Professional Details</h3>
              <div className="grid sm:grid-cols-2 gap-x-10 gap-y-6" data-testid="about-editable-fields">
                {editable.map(([label, val]) => (
                  <div key={label} className="border-b border-[#E6EBF0] pb-4">
                    <span className="label text-[0.55rem]">{label}</span>
                    <p className="mt-1.5 text-[#0B1B2B] font-medium">{val}</p>
                  </div>
                ))}
              </div>
              <p className="mt-4 text-xs text-[#64748B] italic font-mono">
                Fields in placeholders are editable via the admin panel and will be completed by Catalyst Solutions.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
